module.exports = __webpack_public_path__ + "fonts/SegoeUI-SemiBold.2c06a377.woff2";